import { useMemo } from 'react';
import type { SkillSnapshot } from './types';
import { diffDocuments } from './document-diff';

function text(snapshot: SkillSnapshot) {
  return [`# ${snapshot.name}`, snapshot.description, snapshot.instructions]
    .filter(Boolean)
    .join('\n\n');
}

/** Compare only the displayed draft with the exact published snapshot. */
export function useSkillChanges(draft?: SkillSnapshot, published?: SkillSnapshot | null) {
  return useMemo(
    () =>
      draft && published && draft.revision > published.revision
        ? diffDocuments(text(published), text(draft))
        : null,
    [draft, published],
  );
}
